module.exports = __webpack_public_path__ + "media/icons/notification_close@3x-6b919ac2.svg";